import theme from './default-theme';
import alternativeTheme from './alternative-theme';

export default {
  'default-theme': theme,
  'alternative-theme': alternativeTheme,
};
